import { DiffLineContainer, type DiffLinePlacement } from "@ext/git/core/Diff/components/DiffLine/DiffLineContainer";
import { DiffLineMarker } from "@ext/git/core/Diff/components/DiffLine/DiffLineMarker";
import {
	DiffLinePopoverContent,
	DiffLinePopoverHeader,
	DiscardButton,
} from "@ext/git/core/Diff/components/DiffLine/DiffLinePopover";
import { useHoverPopover } from "@ext/git/core/Diff/logic/hooks/useHoverPopover";
import t from "@ext/localization/locale/translate";
import { Popover, PopoverAnchor } from "@ui-kit/Popover";

export const AddedDiffLine = ({ placement, onDiscard }: { placement: DiffLinePlacement; onDiscard: () => void }) => {
	const hover = useHoverPopover();
	return (
		<Popover onOpenChange={hover.setOpen} open={hover.open}>
			<DiffLineContainer interactive placement={placement} type="added">
				<PopoverAnchor asChild>
					<div className="h-[inherit] w-full" {...hover.triggerProps}>
						<DiffLineMarker height={placement.height} type="added" />
					</div>
				</PopoverAnchor>
			</DiffLineContainer>
			<DiffLinePopoverContent className="w-auto overflow-hidden p-0 pb-2" {...hover.contentProps}>
				<DiffLinePopoverHeader
					action={
						<DiscardButton
							onClick={() => {
								hover.close();
								onDiscard();
							}}
							qa="diff-added-discard"
						/>
					}
					title={t("diff.type.added")}
				/>
			</DiffLinePopoverContent>
		</Popover>
	);
};
